import { request } from '../../../../global/api/legacyApi'
import {
  HTTPMethod,
  type APIResponse,
} from '../../../../sharedLegacy/utils/api.types'

const liveSectionEndpoint = () => ({
  add: () => '/api/2/live/section/add',
})

type AddRequest = {
  /** ID of the live event or webinar for the live section */
  live_id: number
}

type AddResponse = {
  /** ID of the live section created */
  live_section_id: number
}

export async function addHighlight(
  liveId: number
): Promise<{ liveSectionId: number }> {
  const { data } = await request<APIResponse<AddResponse>>({
    method: HTTPMethod.POST,
    url: liveSectionEndpoint().add(),
    data: {
      live_id: liveId,
    } satisfies AddRequest,
  })
  return { liveSectionId: data.live_section_id }
}
